export default "__VITE_ASSET__8de886fe__"